import { render, staticRenderFns } from "./InsFooterLayout.vue?vue&type=template&id=33a1ff6f&scoped=true&"
import script from "./InsFooterLayout.vue?vue&type=script&lang=ts&"
export * from "./InsFooterLayout.vue?vue&type=script&lang=ts&"
import style0 from "./InsFooterLayout.vue?vue&type=style&index=0&id=33a1ff6f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a1ff6f",
  null
  
)

export default component.exports